export default __webpack_public_path__ + "media/zurb/img/legacy/icons/notable/pro-verify-7d935a7a5237edcb9fb92aa81aa73fce.png";